import {ReactNode} from 'react'
import {HeadProvider} from 'react-head'

export const withHead = (component: () => ReactNode) => () => <HeadProvider>{component()}</HeadProvider>
